import classNames from 'classnames';
import React from 'react';
import * as WixNewIcons from 'wix-ui-icons-common';

import { CustomIconNames } from './custom-icon-names';
import styles from './icon.scss';
import * as Icons from './icons';
import { NewIconNames } from './new-icon-names';
import { SystemIconNames } from './system-icon-names';

export type IconNames = NewIconNames | SystemIconNames | CustomIconNames;

const DEFAULT_OLD_ICON_FONT_SIZE = 15;

export enum Theme {
  Circle = 'circle',
  EmptyLink = 'emptyLink',
}

interface Props {
  name: IconNames;
  theme?: Theme;
  fontSize?: number;
  className?: string;
  dataHook?: string;
  onClick?: any;
}

export const Icon = ({ name, fontSize, dataHook, theme, ...props }: Props) => {
  const iconClassNames = classNames(styles.icon, props.className, {
    [styles.circle]: theme === Theme.Circle,
    [styles.emptyLink]: theme === Theme.EmptyLink,
  });

  const NewIconComponent = WixNewIcons[name];
  if (NewIconComponent) {
    const size = fontSize === undefined ? undefined : `${fontSize}px`;
    return (
      <span
        className={iconClassNames}
        data-hook={dataHook}
        onClick={props.onClick}
      >
        <NewIconComponent size={size} />
      </span>
    );
  }

  const styleObject = {
    fontSize: fontSize === undefined ? DEFAULT_OLD_ICON_FONT_SIZE : fontSize,
  };

  return (
    <span
      {...props}
      data-hook={dataHook}
      style={styleObject}
      className={classNames(styles.oldIcon, iconClassNames)}
    >
      <img src={Icons[name]} />
    </span>
  );
};

export default Icon;
